
import { createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { ITextContentsState } from './TextContentsSliceModels'
import { setTextContentsThunkAction } from './middleware/TextContentsThunkActions'
import { AppLinks } from 'enviroment/AppLinks'
import apphistory from 'common/AppHistory'



export const initialTextContentsState: ITextContentsState = {
   basicInfoFormPage: {},
   addressInfoFormPage: {},
   extendedInfoFormPage: {},
   collectPersonalIdFormPage: {},
   mObywatelExtendedInfoFormPage: {},
   bankVerificationPage: {},
   cancelApplicationPage: {},
   failPage: {},
   successPage: {},
   chooseIdentityMethodPage: {},
   mObywatelIdentityPage: {},
   contractSigningPage: {},
   productPage: {},
   retentionPage: {},
   clientPeselReservedPage: {},
   modals: {},
   buttons: {
      backToPartner: "Wróć do partnera",
   },
   offerSummaryWidget: {},
   errorPage: {
      header: 'Ooops!',
      mainContent: {
         part1: 'Coś poszło nie tak. Robimy wszystko co w naszej mocy, żeby naprawić problem.',
         part2: 'Cofnij się bądź odśwież stronę.'
      }   
   },
   videoVerificationErrorPage : {},
   videoVerificationStartPage: {},
   loaders: {
      default: 'Daj nam chwilę',
      startPage: 'Trwa przekierowanie'
   },
   footer: {
      mainFooterInfoText: 'Payka - kredyt konsumencki udzielany przez <b><a href="https://paytree.pl/" target="_blank" rel="noreferrer">Paytree SA</a></b>'
   },
   sessionEndPage: {
      header: 'Sesja wygasła',
      mainContent: {
         part1: 'Ze względów bezpieczeństwa zakończyliśmy sesję. Rozpocznij proces jeszcze raz.',
         part2: 'Za chwilę zostaniesz automatycznie przekierowany do partnera.'
      } 
   },
}

export const textContentsSlice = createSlice({
  name: SLICE_KEYS.TEXT_CONTENTS_SLICE,
  initialState: initialTextContentsState,
  reducers: {},
  extraReducers(builder) {
   builder.addCase(setTextContentsThunkAction.fulfilled, (state, action) => {
      state.basicInfoFormPage = action.payload.basicInfoFormPage
      state.addressInfoFormPage = action.payload.addressInfoFormPage
      state.extendedInfoFormPage = action.payload.extendedInfoFormPage
      state.collectPersonalIdFormPage = action.payload.collectPersonalIdFormPage
      state.mObywatelExtendedInfoFormPage = action.payload.mObywatelExtendedInfoFormPage
      state.bankVerificationPage = action.payload.bankVerificationPage
      state.cancelApplicationPage = action.payload.cancelApplicationPage
      state.videoVerificationErrorPage = action.payload.videoVerificationErrorPage
      state.videoVerificationStartPage = action.payload.videoVerificationStartPage
      state.errorPage = action.payload.errorPage
      state.failPage = action.payload.failPage
      state.sessionEndPage = action.payload.sessionEndPage
      state.successPage = action.payload.successPage
      state.chooseIdentityMethodPage = action.payload.chooseIdentityMethodPage
      state.mObywatelIdentityPage = action.payload.mObywatelIdentityPage
      state.contractSigningPage = action.payload.contractSigningPage
      state.productPage = action.payload.productPage
      state.clientPeselReservedPage = action.payload.clientPeselReservedPage

      state.retentionPage = action.payload.retentionPage
      state.loaders = action.payload.loaders
      state.footer = action.payload.footer
      state.buttons = action.payload.buttons
      state.modals = action.payload.modals
      state.offerSummaryWidget = action.payload.offerSummaryWidget
   })
   builder.addCase(setTextContentsThunkAction.rejected, (state, action) => {
      apphistory.push(AppLinks.error) // Jeśli nie uda się pobrać tekstó na stronę, uznajemy to za błąd i kierujemy na stronę z błędem
      return
   })
}
})

export default textContentsSlice.reducer